import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal } from 'reactstrap';
import { addCompetitor } from 'services/api/competition-analysis';
import { fetchSocialAccountsThunk } from 'slices/auth/thunk';
import { fetchCompetitionAnalysisGroupsThunk, fetchCompetitorsThunk } from 'slices/competitionAnalysis/thunk';
import { AppDispatch, RootState } from 'store';
import { CompetitionGroup } from 'types/competition-analysis';
import { getErrorMessage } from 'utils/helpers';
import { markGroupDataExpired } from 'slices/competitionAnalysis/reducer';
import { platforms } from 'constants/global';
import instagramPlatformLogo from "../../assets/images/platforms/platform-instagram.png"
import youtubePlatformLogo from "../../assets/images/platforms/platform-youtube.png"
const platformLogos = {
    ig: instagramPlatformLogo,
    yt: youtubePlatformLogo
};
const AddCompetitorModal: React.FC<{ isOpen: boolean, onClose: () => void }> = ({ isOpen, onClose }) => {
    const [processing, setProcessing] = useState(false);

    const dispatch = useDispatch<AppDispatch>();
    const [errors, setErrors] = useState<{ handle?: string, platform?: string }>({});


    const [data, setData] = useState<{ platform: string, handle: string }>({ platform: 'ig', handle: '' });

    useEffect(() => {
        if (isOpen) {
            setData({ platform: 'ig', handle: '' })
        }
    }, [isOpen])

    const availablePlatforms = [platforms.ig];

    const validateForm = () => {
        let newErrors: { handle?: string } = {};

        if (!data.handle) {
            newErrors.handle = "Please enter your social media handle or profile link.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }
    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (!validateForm() || !selectedAgencyId) return;
        try {
            setProcessing(true);
            await addCompetitor(selectedAgencyId, data)
            toast.success("Competitor added successfully.");
            onClose();
            dispatch(fetchCompetitorsThunk({ force: true }));
        } catch (error: any) {
            console.error(error);
            toast.error(getErrorMessage(error) || "Failed to add competitor. Please try again.");
        } finally {
            setProcessing(false);
        }
    }

    useEffect(() => {
        if (isOpen) {
            dispatch(fetchSocialAccountsThunk({ force: false }));
        }
    }, [isOpen])

    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className='application-cost-approval-modal' >
            <div className="modal-body">
                <h6 className='application-cost-approval-modal-title mb-3'>Add Competitor</h6>
                <div className="mt-4 d-flex flex-column gap-3">
                    <div className="d-flex flex-column gap-3">
                        <div className="form-group">
                            <div className="d-flex flex-column">
                                <label htmlFor="campaignGoal">Platform <span className="text-danger">*</span></label>
                            </div>
                            <div className="logo-radio-tile-group">
                                {
                                    Object.values(availablePlatforms).map((platform) => (
                                        <div key={platform.id} className={`logo-radio-tile cursor-pointer ${platform.id === data.platform ? 'active' : ''}`} onClick={() => {
                                            setData({ ...data, platform: platform.id })
                                        }}>
                                            <img className='h-100' src={platformLogos[platform.id as keyof typeof platformLogos]} />
                                        </div>
                                    ))
                                }
                            </div>
                            {errors.platform && <div className="text-danger font-12 mt-1">{errors.platform}</div>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="platform">Competitor Handle/Profile Link <span className="text-danger">*</span></label>
                            <input value={data.handle ?? ''}
                                onChange={(e) => {
                                    setData({ ...data, handle: e.target.value })
                                }} type="text" className="form-control profile-input-form-control" id="handle" name="handle" placeholder="Enter competitor's social media handle or profile link" />
                            {errors.handle && <div className="text-danger font-12 mt-1">{errors.handle}</div>}
                        </div>
                    </div>
                </div>

                {/* Save Changes Button */}
                <div className="mt-4 d-flex justify-content-between align-items-center gap-4">
                    <button className="btn btn-gradient-outline w-50" onClick={onClose}>Cancel</button>
                    <button onClick={handleSubmit} className="btn btn-gradient w-50" disabled={processing || (!data.handle)}>{processing ? 'Adding...' : 'Add'}</button>
                </div>
            </div>
        </Modal >
    )
}

export default AddCompetitorModal
